import React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';

import type { InterventionCenterGovStatistics } from '../../../common/types/statistics/fhbfStatistics';
import formatter from '../../../common/helpers/formatter';
import onwardPlacementForm from '../../../clients/detail/fhbfForm/interventionCenter/onwardPlacementForm';
import OptionField from './components/OptionField';

type Props = {
  statistics: InterventionCenterGovStatistics;
};

function ReferralAndRecommendation({ statistics }: Props) {
  const onwardPlacementOptions = formatter.getFieldSelectOptions('onwardPlacement', onwardPlacementForm.fields);

  return (
    <Paper
      elevation={0}
      sx={{
        display: 'block',
        padding: '0px 24px 20px 24px',
        maxWidth: '650px',
        minWidth: '300px',
      }}
    >
      <Grid container>
        <Grid item xs={12}>
          <Typography fontSize='0.9rem' fontWeight='bold'>
            6 Weitervermittlung und Weiterempfehlung:
          </Typography>
        </Grid>
        <Grid item xs={12} mb={1}>
          <Divider sx={{ borderBottomWidth: 2, borderColor: '#000000' }} />
          <Typography fontSize='0.75rem'>
            <b>Hinweis:</b> Hier bitte Anzahl der Frauen/Fälle angeben, bei denen eine Kontaktaufnahme mit den genannten
            Einrichutungen empfohlen wurde und Frauen, die fallbezogen direkt an diese vermittelt wurden.
          </Typography>
          <Divider sx={{ borderBottomWidth: 2, borderColor: '#000000' }} />
        </Grid>
        <Grid item xs={7}>
          <Typography fontSize='0.9rem' fontWeight='bold'>
            6.1 Anzahl der beratenen Frauen mit Weitervermittlung/-empfehlung insgesamt
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography
            fontSize='0.9rem'
            fontWeight='bold'
            borderTop='2px solid black'
            borderLeft='2px solid black'
            borderRight='2px solid black'
            p='5px'
            align='right'
            height='100%'
          >
            {statistics.numberOfClientsWithOnwardPlacement}
          </Typography>
        </Grid>
        <Grid item xs={7}>
          <Typography fontSize='0.9rem'>
            Davon direkte fallbezogene Kontaktaufnahme durch die IST zu anderer Einrichtung
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography
            fontSize='0.9rem'
            borderTop='2px solid black'
            borderLeft='2px solid black'
            borderRight='2px solid black'
            px='5px'
            align='right'
            height='100%'
          >
            {statistics.numberOfOnwardPlacementDirectContact}
          </Typography>
        </Grid>
        <Grid item xs={7}>
          <Typography fontSize='0.9rem'>Davon nur Weitergabe der Kontaktdaten</Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography
            fontSize='0.9rem'
            borderTop='2px solid black'
            borderLeft='2px solid black'
            borderRight='2px solid black'
            px='5px'
            align='right'
          >
            {statistics.numberOfOnwardPlacementContactDetails}
          </Typography>
        </Grid>
        <Grid item xs={7}>
          <Typography fontSize='0.9rem'>Beides</Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography fontSize='0.9rem' border='2px solid black' px='5px' align='right'>
            {statistics.numberOfOnwardPlacement}
          </Typography>
        </Grid>
        <Grid item xs={12} mt={1}>
          <Typography fontSize='0.9rem' fontWeight='bold'>
            6.2 Weitervermittlung und Weiterempfehlung erfolgte an folgende Stellen (Mehrfachnennung möglich)
          </Typography>
        </Grid>
      </Grid>
      <Grid container rowSpacing={2} mt={1} className='fhbf-print-text-value-border'>
        {onwardPlacementOptions.map((option) => (
          <OptionField
            key={`onwardPlacement_${option.value}`}
            label={option.label}
            value={statistics.onwardPlacement[option.value]}
          />
        ))}
      </Grid>
    </Paper>
  );
}

export default ReferralAndRecommendation;
